skrilla.service('cacheService', function(){
    var objects = {};

    var registerObject = function(key, data){
        //if array just empty and re-populate as to not lose pointer
        if((isArray(objects[key]) && isArray(data)) ){ //|| objects[key] === undefined && isArray(data)
            //if the objects share a pointer, no need to mess with it
            if(objects[key] !== data) {
                objects[key].length = 0;
                data.forEach(function (i) {
                    objects[key].push(i);
                });
            }
        }
        else {
            objects[key] = data;
        }
        return objects[key];
    }

    var getObject = function(key){ return objects[key];}

    var getObjectOrElse = function(key, orElse){
        if(objects[key] === null || objects[key] === undefined){
            if(orElse && {}.toString.call(orElse) === '[object Function]'){
                return orElse();
            }
            return orElse;
        }
        return objects[key];
    }

    var wipeObject = function(key){
        delete objects[key];
    }

    function isArray(value){return value !== undefined && value !== null && value.constructor === Array;}

    return {
        registerObject: registerObject,
        getObject: getObject,
        getObjectOrElse: getObjectOrElse,
        wipeObject: wipeObject
    };
});

